/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BankAccountResponseDto,
  BrokerGroupsResponseDto,
  BusinessLineResponseDto,
  CrestaZoneResponseDto,
  CurrencyRateRequestDto,
  CurrencyRateResponseDto,
  CurrencyResponseDto,
  ErrorResponse,
  FilterOccupancyLossCostRatesDto,
  FilterSeverityRatesDto,
  FilterTaxRatesDto,
  GetMainRegionAndRiskTerritoryListQueryDto,
  InterpolationResultResponseDto,
  LossCauseResponseDto,
  MainRegionAndRiskTerritoryResponseDto,
  OccupancyLossCostRatesResponseDto,
  OccupancyResponseDto,
  PlacingTypeResponseDto,
  PrincipalOccupationResponseDto,
  SeverityRatesResponseDto,
  SubClassResponseDto,
  TaxRateResponseDto,
  TbaConfigResponseDto,
  UpsertCurrencyRateLockRequestDto,
} from '../models/index';
import {
    BankAccountResponseDtoFromJSON,
    BankAccountResponseDtoToJSON,
    BrokerGroupsResponseDtoFromJSON,
    BrokerGroupsResponseDtoToJSON,
    BusinessLineResponseDtoFromJSON,
    BusinessLineResponseDtoToJSON,
    CrestaZoneResponseDtoFromJSON,
    CrestaZoneResponseDtoToJSON,
    CurrencyRateRequestDtoFromJSON,
    CurrencyRateRequestDtoToJSON,
    CurrencyRateResponseDtoFromJSON,
    CurrencyRateResponseDtoToJSON,
    CurrencyResponseDtoFromJSON,
    CurrencyResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterOccupancyLossCostRatesDtoFromJSON,
    FilterOccupancyLossCostRatesDtoToJSON,
    FilterSeverityRatesDtoFromJSON,
    FilterSeverityRatesDtoToJSON,
    FilterTaxRatesDtoFromJSON,
    FilterTaxRatesDtoToJSON,
    GetMainRegionAndRiskTerritoryListQueryDtoFromJSON,
    GetMainRegionAndRiskTerritoryListQueryDtoToJSON,
    InterpolationResultResponseDtoFromJSON,
    InterpolationResultResponseDtoToJSON,
    LossCauseResponseDtoFromJSON,
    LossCauseResponseDtoToJSON,
    MainRegionAndRiskTerritoryResponseDtoFromJSON,
    MainRegionAndRiskTerritoryResponseDtoToJSON,
    OccupancyLossCostRatesResponseDtoFromJSON,
    OccupancyLossCostRatesResponseDtoToJSON,
    OccupancyResponseDtoFromJSON,
    OccupancyResponseDtoToJSON,
    PlacingTypeResponseDtoFromJSON,
    PlacingTypeResponseDtoToJSON,
    PrincipalOccupationResponseDtoFromJSON,
    PrincipalOccupationResponseDtoToJSON,
    SeverityRatesResponseDtoFromJSON,
    SeverityRatesResponseDtoToJSON,
    SubClassResponseDtoFromJSON,
    SubClassResponseDtoToJSON,
    TaxRateResponseDtoFromJSON,
    TaxRateResponseDtoToJSON,
    TbaConfigResponseDtoFromJSON,
    TbaConfigResponseDtoToJSON,
    UpsertCurrencyRateLockRequestDtoFromJSON,
    UpsertCurrencyRateLockRequestDtoToJSON,
} from '../models/index';

export interface CreateCurrencyRateRequest {
    currencyRateRequestDto: CurrencyRateRequestDto;
}

export interface FilterOccupancyLossCostRatesRequest {
    filterOccupancyLossCostRatesDto: FilterOccupancyLossCostRatesDto;
}

export interface FilterSeverityRatesRequest {
    filterSeverityRatesDto: FilterSeverityRatesDto;
}

export interface FilterTaxRatesRequest {
    filterTaxRatesDto: FilterTaxRatesDto;
}

export interface GetBusinessLinesRequest {
    placingType?: string;
}

export interface GetMainRegionAndRiskTerritoryListRequest {
    getMainRegionAndRiskTerritoryListQueryDto: GetMainRegionAndRiskTerritoryListQueryDto;
}

export interface GetOccupancyLossCostRatesByOccupancyNameRequest {
    occupancyName: string;
}

export interface GetPlacingTypesRequest {
    policyType?: string;
}

export interface GetSubClassesRequest {
    lineOfBusiness?: string;
}

export interface InterpolateSeverityRatesRequest {
    percentage: number;
}

export interface UpsertCurrencyRateLockRequest {
    upsertCurrencyRateLockRequestDto: UpsertCurrencyRateLockRequestDto;
}

/**
 * 
 */
export class ReferenceDataApi extends runtime.BaseAPI {

    /**
     * Create currency rate
     */
    async createCurrencyRateRaw(requestParameters: CreateCurrencyRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CurrencyRateResponseDto>>> {
        if (requestParameters['currencyRateRequestDto'] == null) {
            throw new runtime.RequiredError(
                'currencyRateRequestDto',
                'Required parameter "currencyRateRequestDto" was null or undefined when calling createCurrencyRate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reference-data/currency-rate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CurrencyRateRequestDtoToJSON(requestParameters['currencyRateRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CurrencyRateResponseDtoFromJSON));
    }

    /**
     * Create currency rate
     */
    async createCurrencyRate(requestParameters: CreateCurrencyRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CurrencyRateResponseDto>> {
        const response = await this.createCurrencyRateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter all business lines that are eligible for claim assignment
     */
    async filterBusinessLinesClaimsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BusinessLineResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/business-lines/eligible-for-claim`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BusinessLineResponseDtoFromJSON));
    }

    /**
     * Filter all business lines that are eligible for claim assignment
     */
    async filterBusinessLinesClaims(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BusinessLineResponseDto>> {
        const response = await this.filterBusinessLinesClaimsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Filter occupancy loss cost rates
     */
    async filterOccupancyLossCostRatesRaw(requestParameters: FilterOccupancyLossCostRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OccupancyLossCostRatesResponseDto>>> {
        if (requestParameters['filterOccupancyLossCostRatesDto'] == null) {
            throw new runtime.RequiredError(
                'filterOccupancyLossCostRatesDto',
                'Required parameter "filterOccupancyLossCostRatesDto" was null or undefined when calling filterOccupancyLossCostRates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reference-data/occupancy-loss-cost-rates/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterOccupancyLossCostRatesDtoToJSON(requestParameters['filterOccupancyLossCostRatesDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OccupancyLossCostRatesResponseDtoFromJSON));
    }

    /**
     * Filter occupancy loss cost rates
     */
    async filterOccupancyLossCostRates(requestParameters: FilterOccupancyLossCostRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OccupancyLossCostRatesResponseDto>> {
        const response = await this.filterOccupancyLossCostRatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter severity rates
     */
    async filterSeverityRatesRaw(requestParameters: FilterSeverityRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SeverityRatesResponseDto>>> {
        if (requestParameters['filterSeverityRatesDto'] == null) {
            throw new runtime.RequiredError(
                'filterSeverityRatesDto',
                'Required parameter "filterSeverityRatesDto" was null or undefined when calling filterSeverityRates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reference-data/severity-rates/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterSeverityRatesDtoToJSON(requestParameters['filterSeverityRatesDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SeverityRatesResponseDtoFromJSON));
    }

    /**
     * Filter severity rates
     */
    async filterSeverityRates(requestParameters: FilterSeverityRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SeverityRatesResponseDto>> {
        const response = await this.filterSeverityRatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter tax rates
     */
    async filterTaxRatesRaw(requestParameters: FilterTaxRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaxRateResponseDto>>> {
        if (requestParameters['filterTaxRatesDto'] == null) {
            throw new runtime.RequiredError(
                'filterTaxRatesDto',
                'Required parameter "filterTaxRatesDto" was null or undefined when calling filterTaxRates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reference-data/tax-rates/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterTaxRatesDtoToJSON(requestParameters['filterTaxRatesDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaxRateResponseDtoFromJSON));
    }

    /**
     * Filter tax rates
     */
    async filterTaxRates(requestParameters: FilterTaxRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaxRateResponseDto>> {
        const response = await this.filterTaxRatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get bank accounts
     */
    async getBankAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BankAccountResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reference-data/bank-account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BankAccountResponseDtoFromJSON));
    }

    /**
     * Get bank accounts
     */
    async getBankAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BankAccountResponseDto>> {
        const response = await this.getBankAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get broker groups
     */
    async getBrokerGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BrokerGroupsResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/broker-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BrokerGroupsResponseDtoFromJSON));
    }

    /**
     * Get broker groups
     */
    async getBrokerGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BrokerGroupsResponseDto>> {
        const response = await this.getBrokerGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get business lines
     */
    async getBusinessLinesRaw(requestParameters: GetBusinessLinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BusinessLineResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['placingType'] != null) {
            queryParameters['placingType'] = requestParameters['placingType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/business-line`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BusinessLineResponseDtoFromJSON));
    }

    /**
     * Get business lines
     */
    async getBusinessLines(requestParameters: GetBusinessLinesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BusinessLineResponseDto>> {
        const response = await this.getBusinessLinesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get cresta zones
     */
    async getCrestaZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CrestaZoneResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/cresta-zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CrestaZoneResponseDtoFromJSON));
    }

    /**
     * Get cresta zones
     */
    async getCrestaZones(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CrestaZoneResponseDto>> {
        const response = await this.getCrestaZonesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get currencies
     */
    async getCurrenciesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CurrencyResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/currency`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CurrencyResponseDtoFromJSON));
    }

    /**
     * Get currencies
     */
    async getCurrencies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CurrencyResponseDto>> {
        const response = await this.getCurrenciesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get loss causes
     */
    async getLossCausesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LossCauseResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/loss-cause`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LossCauseResponseDtoFromJSON));
    }

    /**
     * Get loss causes
     */
    async getLossCauses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LossCauseResponseDto>> {
        const response = await this.getLossCausesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get main region and risk territory list
     */
    async getMainRegionAndRiskTerritoryListRaw(requestParameters: GetMainRegionAndRiskTerritoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MainRegionAndRiskTerritoryResponseDto>>> {
        if (requestParameters['getMainRegionAndRiskTerritoryListQueryDto'] == null) {
            throw new runtime.RequiredError(
                'getMainRegionAndRiskTerritoryListQueryDto',
                'Required parameter "getMainRegionAndRiskTerritoryListQueryDto" was null or undefined when calling getMainRegionAndRiskTerritoryList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reference-data/main-region-and-risk-territory/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetMainRegionAndRiskTerritoryListQueryDtoToJSON(requestParameters['getMainRegionAndRiskTerritoryListQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MainRegionAndRiskTerritoryResponseDtoFromJSON));
    }

    /**
     * Get main region and risk territory list
     */
    async getMainRegionAndRiskTerritoryList(requestParameters: GetMainRegionAndRiskTerritoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MainRegionAndRiskTerritoryResponseDto>> {
        const response = await this.getMainRegionAndRiskTerritoryListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get occupancies
     */
    async getOccupanciesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OccupancyResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/occupancy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OccupancyResponseDtoFromJSON));
    }

    /**
     * Get occupancies
     */
    async getOccupancies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OccupancyResponseDto>> {
        const response = await this.getOccupanciesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get occupancy loss cost rates
     */
    async getOccupancyLossCostRatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OccupancyLossCostRatesResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/occupancy-loss-cost-rates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OccupancyLossCostRatesResponseDtoFromJSON));
    }

    /**
     * Get occupancy loss cost rates
     */
    async getOccupancyLossCostRates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OccupancyLossCostRatesResponseDto>> {
        const response = await this.getOccupancyLossCostRatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get occupancy loss cost rates by occupancy name
     */
    async getOccupancyLossCostRatesByOccupancyNameRaw(requestParameters: GetOccupancyLossCostRatesByOccupancyNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OccupancyLossCostRatesResponseDto>> {
        if (requestParameters['occupancyName'] == null) {
            throw new runtime.RequiredError(
                'occupancyName',
                'Required parameter "occupancyName" was null or undefined when calling getOccupancyLossCostRatesByOccupancyName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/occupancy-loss-cost-rates/{occupancyName}`.replace(`{${"occupancyName"}}`, encodeURIComponent(String(requestParameters['occupancyName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OccupancyLossCostRatesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get occupancy loss cost rates by occupancy name
     */
    async getOccupancyLossCostRatesByOccupancyName(requestParameters: GetOccupancyLossCostRatesByOccupancyNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OccupancyLossCostRatesResponseDto> {
        const response = await this.getOccupancyLossCostRatesByOccupancyNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get placing types
     */
    async getPlacingTypesRaw(requestParameters: GetPlacingTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlacingTypeResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['policyType'] != null) {
            queryParameters['policyType'] = requestParameters['policyType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/placing-type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlacingTypeResponseDtoFromJSON));
    }

    /**
     * Get placing types
     */
    async getPlacingTypes(requestParameters: GetPlacingTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlacingTypeResponseDto>> {
        const response = await this.getPlacingTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get principal occupations
     */
    async getPrincipalOccupationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrincipalOccupationResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/principal-occupation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrincipalOccupationResponseDtoFromJSON));
    }

    /**
     * Get principal occupations
     */
    async getPrincipalOccupations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrincipalOccupationResponseDto>> {
        const response = await this.getPrincipalOccupationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get sub-classes
     */
    async getSubClassesRaw(requestParameters: GetSubClassesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubClassResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['lineOfBusiness'] != null) {
            queryParameters['lineOfBusiness'] = requestParameters['lineOfBusiness'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/sub-class`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubClassResponseDtoFromJSON));
    }

    /**
     * Get sub-classes
     */
    async getSubClasses(requestParameters: GetSubClassesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubClassResponseDto>> {
        const response = await this.getSubClassesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get TBA environment variables
     */
    async getTbaEnvRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TbaConfigResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/tba-config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TbaConfigResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get TBA environment variables
     */
    async getTbaEnv(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TbaConfigResponseDto> {
        const response = await this.getTbaEnvRaw(initOverrides);
        return await response.value();
    }

    /**
     * Interpolate severity rates
     */
    async interpolateSeverityRatesRaw(requestParameters: InterpolateSeverityRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InterpolationResultResponseDto>> {
        if (requestParameters['percentage'] == null) {
            throw new runtime.RequiredError(
                'percentage',
                'Required parameter "percentage" was null or undefined when calling interpolateSeverityRates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['percentage'] != null) {
            queryParameters['percentage'] = requestParameters['percentage'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reference-data/severity-rates/interpolate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InterpolationResultResponseDtoFromJSON(jsonValue));
    }

    /**
     * Interpolate severity rates
     */
    async interpolateSeverityRates(requestParameters: InterpolateSeverityRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InterpolationResultResponseDto> {
        const response = await this.interpolateSeverityRatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert currency rate lock
     */
    async upsertCurrencyRateLockRaw(requestParameters: UpsertCurrencyRateLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['upsertCurrencyRateLockRequestDto'] == null) {
            throw new runtime.RequiredError(
                'upsertCurrencyRateLockRequestDto',
                'Required parameter "upsertCurrencyRateLockRequestDto" was null or undefined when calling upsertCurrencyRateLock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reference-data/currency-rate-lock`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertCurrencyRateLockRequestDtoToJSON(requestParameters['upsertCurrencyRateLockRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upsert currency rate lock
     */
    async upsertCurrencyRateLock(requestParameters: UpsertCurrencyRateLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertCurrencyRateLockRaw(requestParameters, initOverrides);
    }

}
